import './bootstrap';
import Vue from 'vue';
import Vuex from 'vuex';
import storeFactory from './PublicPlayerProfile/store';
import PublicPlayerProfile from './PublicPlayerProfile/PublicPlayerProfile';
import Axios from 'axios';
import BlastUI from './BlastUI';
import PortalVue from 'portal-vue';
import { i18n, locale } from './vue-i18n';
import ElementUI from "element-ui";

const elementUiLocale = require('element-ui/lib/locale/lang/' + locale);
const apiVersion = 3;

window.axios = Axios.create({
  baseURL: `${window.user.base_url}/api/v${apiVersion}`,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
});

window.axiosV2 = Axios.create({
    baseURL: `${window.user.base_url}`,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    }
});

Vue.use(Vuex);
Vue.use(BlastUI);
Vue.use(PortalVue);
Vue.use(ElementUI, { locale: elementUiLocale });

Vue.prototype.$bus = new Vue();

const store = storeFactory();

new Vue({
    el: '#app',
    i18n,
    store,
    components: { PublicPlayerProfile },
    mounted() {
        this.$i18n.locale = window.preferred_language;
    }
});
